import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function FinalCTA() {
  const { t } = useTranslation();

  const finalFeatures = [
    t('phoenix.finalFeature1'),
    t('phoenix.finalFeature2'),
    t('phoenix.finalFeature3'),
  ];

  return (
    <section className="relative py-24 md:py-32 bg-white overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-white/50 to-transparent pointer-events-none"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] bg-accent-500/[0.02] rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative mx-auto max-w-[900px] px-6 md:px-10 text-center">
        <ScrollReveal direction="up">
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.1] tracking-tight mb-4">
            {t('phoenix.finalTitle')}
          </h2>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.1}>
          <p className="font-heading text-xl md:text-2xl font-semibold text-primary-500 mb-6">
            {t('phoenix.finalSubtitle')}
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.15}>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-[650px] mx-auto mb-10">
            {t('phoenix.finalDesc')}
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.2}>
          <div className="mb-10">
            <span className="font-heading text-5xl md:text-6xl font-bold text-foreground-950">{t('phoenix.finalPrice')}</span>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.25}>
          <a
            href="https://wa.link/em25v1"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-5 rounded-full bg-primary-500 text-white font-bold text-base md:text-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-[0_6px_30px_rgba(229,57,53,0.35)] hover:shadow-[0_8px_40px_rgba(229,57,53,0.5)] hover:-translate-y-0.5 cursor-pointer mb-10"
          >
            {t('phoenix.finalCta')}
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.3}>
          <div className="flex flex-wrap items-center justify-center gap-6">
            {finalFeatures.map((f, i) => (
              <div key={i} className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-check-line text-primary-500"></i>
                {f}
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}